import PropTypes from "prop-types";
import Layout from "./Layout";
import {createRef} from "react";
import GF from "../../utils/GF";

class VerticalLayout extends Layout {

  constructor(props) {
    super(props);
    this.bodyRef = createRef();
  }

  onClick(e) {
    if (this.props.onClick !== undefined) {
      this.props.onClick(e);
    }
  }

  manageStyleObject() {
    let styleValue = {};
    if (this.props.styleValue) {
      styleValue = this.props.styleValue;
    }
    if (this.props.hidden && this.props.hidden === true) {
      styleValue.display = 'none';
    }
    return styleValue;
  }

  getContent() {
    let optionalClasses = this.props.className !== undefined ? this.props.className : '';
    let width = 'w-full ';
    if (this.props.widthFit) {
      width = '';
    }

    return <div id={GF.getValue(this.props.id)}
                ref={this.bodyRef}
                className={'flex flex-col ' + width + optionalClasses}
                onClick={(e) => this.onClick(e)}
                style={this.manageStyleObject()}
                role={GF.getValue(this.props.role, '')}
                aria-labelledby={GF.getValue(this.props.ariaLabelledby, '')}>
      {this.props.children}
    </div>;
  }
}

VerticalLayout.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
  widthFit: PropTypes.bool,
  onClick: PropTypes.func,
  id: PropTypes.string,
  styleValue: PropTypes.object,
  role: PropTypes.string,
  hidden: PropTypes.bool,
  ariaLabelledby: PropTypes.string
}

export default VerticalLayout;
